import DIApi from './_diApi';

class ActivityCategoryAPI extends DIApi {
  controllerName = 'ActivityCategorys';
}

export default new ActivityCategoryAPI();
